import type { UserDataLoginRecord } from '@navio/nsdk';
import { UserRoleType } from '../types/roles';

function hasValidPermission(requiredLoginLevels: UserRoleType[], user: UserDataLoginRecord) {
  // eslint-disable-next-line no-restricted-syntax -- flag set in loop with early break
  let isAllowed = false;

  for (const requiredLoginLevel of requiredLoginLevels) {
    if (user[requiredLoginLevel]) {
      isAllowed = true;
      break;
    }
  }
  return isAllowed;
}

export { hasValidPermission };
